import React from 'react';

const SelectableImageCard = ({ image, onSelect, onToggleSelection, isSelected }) => {
  return (
    <div className={`relative bg-white rounded-lg shadow-lg p-6 flex flex-col transition-all duration-300 hover:shadow-xl ${isSelected ? 'border-2 border-blue-500' : 'border border-gray-200'}`}>
      <input
        type="checkbox"
        checked={isSelected}
        onChange={() => onToggleSelection(image.id)}
        className="absolute top-3 right-3 z-10 w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
      />
      <div 
        className="relative w-full pb-[100%] bg-gray-100 rounded-md overflow-hidden mb-4 flex items-center justify-center cursor-pointer hover:shadow-xl transition-shadow duration-300"
        onClick={() => onSelect(image)}
      >
        <img
          src={image.image_url}
          alt={`Generated T-shirt ${image.prompt}`}
          className="absolute inset-0 w-full h-full object-contain transition-transform duration-300 hover:scale-105"
        />
      </div>
      <p className="text-gray-800 font-semibold mb-1">Prompt: {image.prompt}</p>
      <p className="text-gray-600 text-sm">Style: {image.style}</p>
    </div>
  );
};

export default SelectableImageCard;
